import { jsx as i } from "react/jsx-runtime";
import { af as t } from "../../vendor-CPVnY93G.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as o } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index37.css';const r = "_fieldDescription_a4zry_1", n = {
  fieldDescription: r
};
function l(e) {
  return e.children ? /* @__PURE__ */ i(
    t,
    {
      ...o(e),
      slot: "description",
      elementType: "span",
      className: n.fieldDescription,
      "data-component": "FieldDescription"
    }
  ) : null;
}
export {
  l as FieldDescription
};
